import { render, staticRenderFns } from "./ResponseAnswer.vue?vue&type=template&id=e571dc84"
import script from "./ResponseAnswer.vue?vue&type=script&lang=ts"
export * from "./ResponseAnswer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports